<template>
	<div class="oms-payload">
		
		<!--主要出入-->
		<div class="card-item">
			<div class="card-header">小程序入口页</div>
			<div class="card-payload">
				<van-grid>
					<template v-for="(item,idx) in appItem">
						<van-grid-item 
							:icon="item.icon" 
							:text="item.label" 
							@click="handleSend(idx)"
						/>
					</template>
				</van-grid>
			</div>
		</div>

		<div class="card-item">
			<div class="card-header">运营工具</div>
			<div class="card-payload">
				<van-grid>
					<template v-for="(item,idx) in omsItem">
						<van-grid-item 
							:icon="item.icon" 
							:text="item.label" 
							@click="handleClickOms(idx)"
						/>
					</template>
				</van-grid>
			</div>
		</div>

		<!--分享弹框-->
		<van-popup 
			v-model="send.show" 
			position="bottom" 
			:style="{ height: '60vh' }" 

		>
			<div class="send-payload">
				<div class="title">入口页只能分享小程序</div>
				<div class="content">
					<div class="thalf onehalf">
						<div class="tmini">
							<div class="ttitle">{{send.mini.title}}</div>
							
							<van-image
								class="timage"
								width="150"
								height="150"
								:src="send.mini.image"
							/>
						</div>
					</div>
				</div>

				<van-tabbar v-model="send.type">
					<van-tabbar-item icon="miniprogram-o" @click="handlClickShare('mini')">发送小程序</van-tabbar-item>
				</van-tabbar>
			</div>
		</van-popup>

	</div>
</template>

<script type="text/javascript">
import {wxminiCfg} from '@/config/wxmini';
import {getQwSignature} from '@/interface/qywx/qwglobal';

export default {
    data(){
    	return {
    		//企业微信签名信息
			qywxCfg: {
				agentId: '',
				corpId: '',
				url: '',
				corpTimestamp: '',
				corpNonceStr: '',
				corpSignature: '',
				agentTimestamp: '',
				agentNonceStr: '',
				agentSignature: '',
			},
			qywxCurrent:{
				thirdCode:'qywx',	//来源
				chatId: '',		//当前群ID
				agent: 'oms',	//当前应用
			},
    		appItem:[
    			{label:'小程序首页', title:'找门店、买配件、做保养上云卡,全国维修资源、一站式服务体验！', key:'index', icon:'miniprogram-o', url: 'pages/index/index.html', image: 'http://images.yuntruck.com/default/202507/1751967032448.png'},

    			{label:'维修门店', title:'【云卡】全国维修连锁，上万家入驻汽修门店任你挑选！', key:'shop', icon:'shop-o', url: 'pages/tabbar/shop/shop.html',image: 'http://images.yuntruck.com/default/202507/1751966670591.png'},

    			{label:'配件商城', title:'【云卡】商城精选好品：雪佛龙、康明斯、卡耐能多个品牌随意挑！',key:'mall', icon:'shopping-cart-o', url: 'pages/tabbar/pmall/pmall.html',image: 'http://imageoss.yuntruck.com/202410/172872610812348.png'},

    			{label:'领券中心', title:'故障维修不用愁，领券更省心！',key:'coupon', icon:'coupon-o', url: 'pages/oms/coupon/operate/index/index.html',image: 'http://images.yuntruck.com/default/202507/1751966039890.png'},

    			{label:'保养中心', title:'发动机深度养护、变速箱油更换更多选择方案！' ,key:'baoyang', icon:'logistics', url: 'pages/tabbar/baoyang/baoyang.html',image: 'http://imageoss.yuntruck.com/202408/172319755835797.png'},

    			{label:'保养方案', title:'【云卡】精选燃气车、柴油车大保养、小保养多种组合方案任你挑选！',key:'plan', icon:'brush-o', url: 'pweibao/plans/plan/plan.html',image: 'https://imageoss.yuntruck.com/202409/172534272920863.png'},

    			{label:'特惠车型', title:'【云卡】特惠保养，多种套餐任你选择！', key:'special', icon:'newspaper-o', url: 'pweibao/baoyang/special/special.html',image: 'http://images.yuntruck.com/default/202507/1751966039890.png'},
    			// {label:'调试页面', title:'调试页面',key:'debug', icon:'newspaper-o', url: '/oms/debug',image: ''},
    		],

    		//素材管理
    		omsItem:[
    			{label:'运营素材',  key:'material', icon:'miniprogram-o', url: '/oms/material' },
    		],

    		send:{
				type: '',
				show: false,
				currentIdx: '',
				mini:{
					label: '',
					title: '',
					image: '',
					url:'',
				}	
			},
    	}
    },
    created: function() {
        this.getQywxCfg();
    },
    methods:{
    	handleClickOms: function(idx){
    		let current = this.omsItem[idx];
    		this.$router.push(current.url);
    	},
    	handleSend: function(idx){
			let current = this.appItem[idx];

			this.send.mini = {
				label: current.label,
				title: current.title,
				image: current.image,
				url: current.url
			}

			if( current.key == 'debug' ){
				this.$router.push(current.url);
				return false;
			}else{
				this.send.currentIdx = idx;
				this.send.show = true;
			}
		},
		handlClickShare: function(type){
			if( type == 'mini' ){
				let miniData = {
					title: this.send.mini.title,
					imgUrl: this.send.mini.image,
					page: this.send.mini.url
				}

				this.sendMiniProgram( miniData );
				this.send.show = false;
			}
		},
    	//获取企业微信签名信息
		getQywxCfg: function(){
			let data = {
				app: 'oms',
				url: window.location.href.split('#')[0],
			}

			getQwSignature(data)
				.then( res=>{
					let info = res.response;
					this.qywxCfg = {
						corpId: info.corpId,
						agentId: info.agentId,
						url: info.url,
						corpSignature: info.corpSignature,
						corpTimestamp: info.corpTimestamp,
						corpNonceStr: info.corpNonceStr,
						agentSignature: info.agentSignature,
						agentTimestamp: info.agentTimestamp,
						agentNonceStr: info.agentNonceStr,
					}

					this.qywxInit();
				})
				.catch( err=>{

				})
		},
		//企业微信初始化
		qywxInit: function(){
			let _this = this;

			ww.register({
				corpId: _this.qywxCfg.corpId,       // 必填，当前用户企业所属企业ID
				agentId: _this.qywxCfg.agentId,  // 必填，当前应用的AgentID
				jsApiList: ['getContext','getCurExternalChat','sendChatMessage'], // 必填，需要使用的JSAPI列表
				getConfigSignature,
				getAgentConfigSignature,            // 必填，根据url生成应用签名的回调函数
				onConfigSuccess(res){
					// alert('configSuccess:'+JSON.stringify(res));
				},
				onConfigFail(res){
					alert('企业签名获取失败:'+JSON.stringify(res));
				},
				onConfigComplete(res){
					// alert('configComplete:'+JSON.stringify(res));
				},
				onAgentConfigFail(res){
					alert('应用签名获取失败:'+JSON.stringify(res));
				},          
				onAgentConfigComplete(res){
					// alert('onAgentConfigComplete:'+JSON.stringify(res));
				}				
			})

    		// 根据 url 生成企业签名
			async function getConfigSignature(url) {
				// alert( 'getConfigSignature:'+JSON.stringify(_this.qywxCfg) );
				
				return {
					timestamp: _this.qywxCfg.corpTimestamp,
					nonceStr: _this.qywxCfg.corpNonceStr,
					signature: _this.qywxCfg.corpSignature
				};
			}

			// 根据 url 生成应用签名，生成方法同上，但需要使用应用的 jsapi_ticket
			async function getAgentConfigSignature(url) {
				// alert( 'getAgentConfigSignature:'+JSON.stringify(_this.qywxCfg) );

				return { 
					timestamp: _this.qywxCfg.agentTimestamp,
					nonceStr: _this.qywxCfg.agentNonceStr,
					signature: _this.qywxCfg.agentSignature
				};
			}

			//获取当前群ID
			this.handleCurExternalChat();
		},
		//获取当前群ID
		handleCurExternalChat: function(){
			let _this = this;
			ww.getCurExternalChat({
				success(res){
					_this.qywxCurrent.chatId = res.chatId;
				},
				fail(err){
					alert('群ID获取失败:'+JSON.stringify(res));
				},
				complete: function(res){
					// alert('ExternalChat-complete:'+JSON.stringify(res));
				}
			})
		},
		/**
		 *分享小程序
		 *@param map miniData 小程序参数
		 *			title: 	标题
		 *			imageUrl 图片路径，以.html结尾
		 *			page:   跳转路径
		 */
		sendMiniProgram: function(miniData){
			let pageUrl = miniData.page;
				pageUrl+= '?thirdCode='+this.qywxCurrent.thirdCode;
				pageUrl+= '&agent='+this.qywxCurrent.agent;
				pageUrl+= '&chatId='+this.qywxCurrent.chatId;
				
			ww.sendChatMessage({
				msgtype: 'miniprogram',
				miniprogram: {
					appid: wxminiCfg.newClient.appId,
					title: miniData.title,
					imgUrl: miniData.imgUrl,
					page: pageUrl,
				},
				success(res){
					// alert('小程序发送成功:'+JSON.stringify(res));
				},
				fail(err){
					// alert('小程序发送失败:'+JSON.stringify(res));
				},
				complete: function(res){
					// alert('handleMiniProgram-complete:'+JSON.stringify(res));
				}
			})
		},
    }
}
</script>